/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取文件权限
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetFileACLParams {
  constructor(public filePath: string) {}
}

export default async function (
  params: GetFileACLParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/fileACL`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
